document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-tk-blog-widget-root]');
  if (!root) return;

  var topWidget = root.querySelector('[data-widget-slot="top"]');
  var midWidget = root.querySelector('[data-widget-slot="mid"]');
  var bottomWidget = root.querySelector('[data-widget-slot="bottom"]');

  var content = document.querySelector('.rte');

  if (topWidget && content) {
    content.insertAdjacentElement('beforebegin', topWidget);
    topWidget.classList.remove('tk-blog-widget--hidden');
  }

  if (midWidget && content) {
    var paragraphs = content.querySelectorAll('p');
    var inserted = false;

    if (paragraphs.length >= 3) {
      paragraphs[2].insertAdjacentElement('afterend', midWidget);
      inserted = true;
    } else if (paragraphs.length >= 1) {
      paragraphs[0].insertAdjacentElement('afterend', midWidget);
      inserted = true;
    } else {
      var headings = content.querySelectorAll('h2, h3');
      if (headings.length >= 1) {
        headings[0].insertAdjacentElement('afterend', midWidget);
        inserted = true;
      }
    }

    if (!inserted) {
      content.appendChild(midWidget);
    }

    midWidget.classList.remove('tk-blog-widget--hidden');
  }

  if (bottomWidget) {
    bottomWidget.classList.remove('tk-blog-widget--hidden');
  }
});
